import { Component, ElementRef, HostListener, Input, OnInit, Pipe, PipeTransform, Renderer2, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { BasketService, DataStoreService } from 'src/app/services';
import { PaymentService } from 'src/app/services/payment.service';
import { SafeResourceUrl, SafeHtml } from '@angular/platform-browser';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})

export class PaymentComponent implements OnInit {

  company;
  companyId;
  orderId;
  amount;
  booking;
  bookingId;
  currentPage: string;
  htmlCode: SafeResourceUrl;
  urlSafe: SafeHtml;
  currency = 'EUR';
  clientEmail: string;

  @ViewChild('iframe') iframe: ElementRef;

  globalInstance: any;

  constructor(
    private router: Router,
    private DataStore: DataStoreService,
    private basketService: BasketService,
    private spinner: NgxSpinnerService,
    private paymentService: PaymentService,
    private apiService: ApiService,) { }

  ngOnInit(): void {

    if (this.DataStore.selectedLocation) {
      this.company = this.DataStore.selectedLocation;
      this.companyId = this.DataStore.selectedLocation.membership_id;
      this.amount = this.DataStore.checkoutData.price;
      this.currentPage = window.location.href;
      this.orderId = this.DataStore.checkoutData.id;
      this.clientEmail = this.DataStore.clientDetails.email;

      this.basketService.getPurchase().then(purchase => {        
        purchase.$get('bookings').then(bookings => {            
          this.bookingId = bookings[0].id;        
        });
      });

      this.spinner.hide();
    } else {
      this.routerGoBack();
    }
  }

  
  routerGoBack() {
    this.router.navigate(['/location']);
  }
  
  cancel() {
    this.spinner.show();
    this.apiService.cancelBookings(this.bookingId, this.company).then(() => {
      this.spinner.hide();
      this.router.navigate(['/location']);
    })
  }

}